import styled from 'styled-components';

export const StyledImage = styled.img`
  width: 150px;
  height: 150px;
`;

export const StyledResult = styled.ul`
  list-style: none;
  text-align: left;
  display: inline-block;
  padding: 0;
  margin: 0;
  margin-bottom: 24px;
  padding: 16px;
  li {
    font-size: 18px;
    display: flex;
    align-items: center;
    gap: 8px;
    span {
      max-width: 350px;
      color: #2552f3;
      cursor: pointer;
      user-select: none;
      white-space: nowrap;
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;
